export default "__VITE_ASSET__B5yivel3__"